export const STEP_FORWARD = 'STEP_FORWARD';
export const STEP_BACK = 'STEP_BACK';
export const REVIEW_INSTRUCTION = 'REVIEW_INSTRUCTION';
export const CONTACT_SUPPORT = 'CONTACT_SUPPORT';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SKIP_INSTRUCTIONS = 'SKIP_INSTRUCTIONS';
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
